export const validateHostname = (value) =>
  /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*|(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})$/.test(
    value
  );

export const validatePort = (value) =>
  value === "" || value === null
    ? 80
    : !/^\d+$/.test(value) || value < 1 || value > 65535
    ? null
    : parseInt(value);

export function isValidNumber(value) {
  // reject null, undefined, empty string
  if (value === null || value === undefined || value === "") {
    return false;
  }

  // convert to number
  const num = Number(value);

  // reject NaN
  return !isNaN(num);
}

export const validateCoord = (value, type) => {
  if (value === "" || value === null) return "Field cannot be empty";

  if (!/^-?\d+(\.\d+)?$/.test(value)) {
    return "not a valid number";
  }

  const num = parseFloat(value);

  if (
    (type === "longitude" && (num < -180 || num > 180)) ||
    (type === "latitude" && (num < -90 || num > 90)) ||
    (type === "elevation" && (num < -500 || num > 9000))
  ) {
    return "out of range";
  }
  return null;
};

export const validateEmail = (value) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i.test(value);

export const validatePassword = (value) =>
  /^.{8,}$/.test(value)
